import env from './../common/env.js';
export default {
    baseUrl: {
        dev: '',
        // pro: 'https://app.hsltm.com:4431'
        pro: env.baseURL
    }
}


// WEBPACK FOOTER //
// ./src/libs/index.js